Object.defineProperty(exports, '__esModule', {
  value: true
});
var firedFunctions = new Set();
/**
 * Given a key and a function, will invoke that function if the key has not yet
 * been previously used to invoke a function
 *
 * @example
   fireOnce("HomePage|Interaction|View Calendar", () => {
     trackEvent({
       eventCategory: "Homepage",
       eventAction: "Interaction",
       eventLabel: "View Calendar",
     });
   });
 */
var fireOnce = function fireOnce(key, func) {
  if (firedFunctions.has(key)) {
    return;
  }
  firedFunctions.add(key);
  return func();
};
/**
 * Resets the list of previously fired functions, allowing all keys to be used
 * again
 */
var reset = function reset() {
  firedFunctions.clear();
};
exports.fireOnce = fireOnce;
exports.reset = reset;